import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const caps = (t) => { const l = t.replace(/[^A-Za-z]/g, ""); return l.length > 1 && l === l.toUpperCase() && !t.startsWith("("); };

export function splitName(full) {
  const w = String(full || "").trim().split(/\s+/).filter(Boolean);
  if (w.length < 2) return { first: w[0] || "", last: "" };
  if (caps(w[w.length - 1]) && !w.every(caps)) {
    let i = w.length;
    while (i > 1 && caps(w[i - 1])) i -= 1;
    return { first: w.slice(0, i).join(" "), last: w.slice(i).join(" ") };
  }
  if (caps(w[0]) && !w.slice(1).some(caps)) return { first: w.slice(1).join(" "), last: w[0] };
  return { first: w.slice(0, -1).join(" "), last: w[w.length - 1] };
}

const join = (n) => (n.first.trim() && n.last.trim() ? `${n.first.trim()} ${n.last.trim()}` : "");

// Two boxes (first + last). onChange gets "First Last", or "" until both are filled in.
export function NameInputs({ value, onChange, testid, label = "Your", className = "h-11 mt-1" }) {
  const [n, setN] = useState(() => splitName(value));
  useEffect(() => { if (value && value !== join(n)) setN(splitName(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k) => (e) => { const next = { ...n, [k]: e.target.value }; setN(next); onChange(join(next)); };
  return (
    <div className="grid grid-cols-2 gap-2">
      <div><label className="text-xs font-semibold text-slate-600">{label} first name *</label>
        <Input data-testid={`${testid}-first`} value={n.first} onChange={set("first")} className={className} autoComplete="given-name" /></div>
      <div><label className="text-xs font-semibold text-slate-600">{label} last name *</label>
        <Input data-testid={`${testid}-last`} value={n.last} onChange={set("last")} className={className} autoComplete="family-name" /></div>
    </div>
  );
}
